import { render, staticRenderFns } from "./otafiles.vue?vue&type=template&id=73ae4087&scoped=true"
import script from "./otafiles.vue?vue&type=script&lang=ts"
export * from "./otafiles.vue?vue&type=script&lang=ts"
import style0 from "./otafiles.vue?vue&type=style&index=0&id=73ae4087&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae4087",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ae4087')) {
      api.createRecord('73ae4087', component.options)
    } else {
      api.reload('73ae4087', component.options)
    }
    module.hot.accept("./otafiles.vue?vue&type=template&id=73ae4087&scoped=true", function () {
      api.rerender('73ae4087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applocalizations/otafiles.vue"
export default component.exports